import React, { useState, useEffect } from "react";
import { useAuth } from "../Context/AuthProvider";
import { Link } from "react-router-dom";

const HeaderWithNav = ({ onclick }) => {
  const userName = (
    localStorage.getItem("user") &&
    JSON.parse(localStorage.getItem("user")).fullName
  )
    .substring(0, 1)
    .toUpperCase();

  const { logOut } = useAuth();

  useEffect(() => {
    var toggleOffIcon = document.getElementById("toggle_off_icon");
    var toggleOnIcon = document.getElementById("toggle_on_icon");

    function toggleContent() {
      toggleOffIcon.style.display =
        toggleOffIcon.style.display === "none" ? "inline-block" : "none";
      toggleOnIcon.style.display =
        toggleOnIcon.style.display === "none" ? "inline-block" : "none";
    }

    var toggleButton = document.getElementById("toggle_sidebar");
    toggleButton.addEventListener("click", toggleContent);

    return () => {
      toggleButton.removeEventListener("click", toggleContent);

    };
  }, []);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    logOut();
  };

  return (
    <header
      id="main_header"
      className="bg-white border-bottom border-light-subtle py-2"
    >
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col">
            <span id="toggle_sidebar" onClick={onclick} className="fs-22">
              <i
                className="bi bi-toggle-off"
                id="toggle_off_icon"
                style={{ display: "none" }}
              ></i>
              <i className="bi bi-toggle-on" id="toggle_on_icon"></i>
            </span>
          </div>
          <div className="col-lg-9">
            <div className="card border-light-subtle">
              <ul className="nav nav-pills custom-nav-pills custom-background custom-navbar-height ">
                <li className="nav-item">
                  <Link to = "/survey-form">
                  <a className="nav-link active" aria-current="page" href="#">
                    Survey Form
                  </a>
                  </Link>
                   
                </li>
                <li className="nav-item">
                  <Link to = "/survey-programming">
                  <a className="nav-link" href="#">
                    Questions
                  </a>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to = "/view-quota">
                  <a className="nav-link" href="#">
                    Quota
                  </a>
                  </Link>
                </li>
                <li className="nav-item">
                  <a className="nav-link">Field Work</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link">Survey Data</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link">Stats</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link">Analysis</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link">Reports</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col">
            <div className="d-flex justify-content-end align-items-center gap-3">
              <a href="#" className="fs-22">
                <i className="bi bi-bell"></i>
              </a>
              <div className="myprofile bg-primary rounded-circle  text-white dropdown">
                <button
                  className="btn btn-success  myprofile rounded-circle"
                  type="button"
                  id="dropdownMenuButton"
                  onMouseOver={toggleDropdown}
                >
                  {userName}
                </button>
                <ul
                  className={`dropdown-menu${isDropdownOpen ? " show" : ""}`}
                  aria-labelledby="dropdownMenuButton"
                  style={{
                    position: "absolute",
                    right: 0,
                    top: "100%",
                    zIndex: 2000,
                  }}
                >
                  <li>
                    <a className="dropdown-item" href="#">
                      Settings
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={handleLogout}>
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderWithNav;
